module.exports = __webpack_public_path__ + "static/media/cross.7b98c6e1.svg";